import { Field } from 'redux-form';
import React from 'react';
import { CountryAutocomplete } from '~molecules';
var CountrySelectField = function (_a) {
    var name = _a.name, title = _a.title, placeholder = _a.placeholder, required = _a.required, _b = _a.options, options = _b === void 0 ? [] : _b, validators = _a.validators;
    return (React.createElement(Field, { name: name, component: CountryAutocomplete, required: required, title: title, options: options, placeholder: placeholder, validate: validators }));
};
export default CountrySelectField;
